import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';

import { CognitoUtil } from '../services/cognito.service';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private cognitoUtil: CognitoUtil, private router: Router) {

    }
    // Implementation for the CanActivate
    canActivate() {
        this.cognitoUtil.isAuthenticated(this);
        return true;
    }

    // Call back function, returns if user is logged In
    isLoggedIn(message: string, isLoggedIn: boolean) {
        if (!isLoggedIn) {
            this.router.navigate(['/login']);
            return false;
        } else {
            return true;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/main/shared/utils/auth.guard.ts